const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

(function () {
  if (!window.location.pathname.startsWith('/products/')) return;

  const STORAGE_KEY = 'sss-size-system-preference';
  const normalize = (v) => String(v || '').replace(/\s+/g, ' ').trim();
  const euSizeRe = /^EU\s*(\d+)(?:\s*\/|$)/i;
  const usMap = {
    '35': '5',
    '36': '5.5–6',
    '37': '6.5–7',
    '38': '7.5–8',
    '39': '8.5',
    '40': '9',
    '41': '9.5–10',
    '42': '10.5–11',
    '43': '11.5–12',
    '44': '12.5–13'
  };

  const getSystem = () => {
    try { return localStorage.getItem(STORAGE_KEY) === 'US' ? 'US' : 'EU'; }
    catch (e) { return 'EU'; }
  };

  const parseValue = (raw) => {
    const value = normalize(raw);
    const euMatch = value.match(euSizeRe);
    if (!euMatch) return null;

    const eu = euMatch[1];
    const parts = value.split('/').map((part) => part.trim()).filter(Boolean);
    let us = '';

    if (parts.length >= 2) {
      us = parts[parts.length - 1]
        .replace(/^US\s*/i, '')
        .replace(/\s*-\s*/g, '–')
        .trim();
    }

    if (!us || /^EU\s*\d+/i.test(us)) us = usMap[eu] || '';
    if (!us) return null;

    return { eu, us };
  };

  const ensureStyles = () => {
    let style = document.getElementById('sss-size-toggle-styles');
    if (style) style.remove();
    style = document.createElement('style');
    style.id = 'sss-size-toggle-styles';
    style.textContent = `
      #sss-size-system-toggle{display:flex!important;align-items:center!important;gap:14px!important;margin:8px 0 14px!important;padding:0!important;visibility:visible!important;opacity:1!important;position:relative!important;z-index:20!important;width:auto!important;height:auto!important;overflow:visible!important}
      #sss-size-system-toggle button{display:inline-block!important;appearance:none!important;border:0!important;border-bottom:2px solid transparent!important;background:transparent!important;color:#111!important;padding:2px 0 4px!important;margin:0!important;min-width:0!important;min-height:0!important;width:auto!important;height:auto!important;font:600 13px/1.2 Arial,sans-serif!important;letter-spacing:.04em!important;cursor:pointer!important;opacity:.42!important;visibility:visible!important}
      #sss-size-system-toggle button.is-active{opacity:1!important;border-bottom-color:#111!important}
      .swatch-button-title-text span.sss-size-display{color:#111!important}
      .swatch-button.sss-size-selected{background:#111!important;border-color:#111!important}
      .swatch-button.sss-size-selected .swatch-button-title-text,
      .swatch-button.sss-size-selected .swatch-button-title-text span.sss-size-display{color:#fff!important}
      .swatch-button:hover .swatch-button-title-text,
      .swatch-button:hover .swatch-button-title-text span.sss-size-display,
      .swatch-button:focus-within .swatch-button-title-text,
      .swatch-button:focus-within .swatch-button-title-text span.sss-size-display,
      li.swatch-view-item:hover .swatch-button-title-text,
      li.swatch-view-item:hover .swatch-button-title-text span.sss-size-display,
      li.swatch-view-item:focus-within .swatch-button-title-text,
      li.swatch-view-item:focus-within .swatch-button-title-text span.sss-size-display,
      .swatch-button.is-selected .swatch-button-title-text span.sss-size-display,
      .swatch-button.selected .swatch-button-title-text span.sss-size-display,
      .swatch-button.active .swatch-button-title-text span.sss-size-display,
      .swatch-button[aria-selected="true"] .swatch-button-title-text span.sss-size-display,
      .swatch-button[aria-pressed="true"] .swatch-button-title-text span.sss-size-display{color:#fff!important}
      li.swatch-view-item.sss-selected-surface,
      li.swatch-view-item.sss-selected-surface > .swatch-button,
      li.swatch-view-item.sss-selected-surface .swatch-title-and-icon-container,
      li.swatch-view-item.sss-selected-surface .swatch-button-title-text{
        background:#111!important;
        background-color:#111!important;
      }
      li.swatch-view-item.sss-selected-surface .swatch-button-title-text,
      li.swatch-view-item.sss-selected-surface .swatch-button-title-text span,
      li.swatch-view-item.sss-selected-surface .swatch-button-title-text span.sss-size-display{
        color:#fff!important;
      }
    `;
    document.head.appendChild(style);
  };

  const isSizeHeadingText = (value) => {
    const text = normalize(value).replace(/:$/, '');
    return text === 'Size' || text === 'Select a Size';
  };

  const getProductRoot = () => document.querySelector('.product-section') || document;

  const findNativeSizeFieldset = () => Array.from(getProductRoot().querySelectorAll('variant-radios fieldset, variant-selects fieldset'))
    .find((fieldset) => {
      const heading = fieldset.querySelector('.product-form__group-name, legend');
      return heading && isSizeHeadingText(heading.textContent);
    }) || null;

  const findHeading = () => {
    const root = getProductRoot();
    const candidates = Array.from(root.querySelectorAll('.product-form__group-name, legend, h1, h2, h3, h4, p, div, span'))
      .filter((el) => isSizeHeadingText(el.textContent));

    const visible = candidates.find((el) => el.isConnected && el.getClientRects().length > 0);
    if (visible) return visible;

    const nativeFieldset = findNativeSizeFieldset();
    return nativeFieldset?.querySelector('.product-form__group-name, legend') || candidates[0] || null;
  };

  const ensureToggle = () => {
    let toggle = document.getElementById('sss-size-system-toggle');
    if (toggle && toggle.isConnected) return toggle;
    const heading = findHeading();
    if (!heading || !heading.parentNode) return null;
    toggle = document.createElement('div');
    toggle.id = 'sss-size-system-toggle';
    toggle.setAttribute('aria-label', 'Choose size system');
    toggle.innerHTML = '<button type="button" data-sss-system="EU" aria-pressed="true">EU</button><button type="button" data-sss-system="US" aria-pressed="false">US</button>';
    heading.insertAdjacentElement('afterend', toggle);
    return toggle;
  };

  const removeToggle = () => {
    const toggle = document.getElementById('sss-size-system-toggle');
    if (toggle) toggle.remove();
  };

  const getNativeSizeState = () => {
    const map = new Map();
    Array.from(document.querySelectorAll('input[type="radio"]')).forEach((input) => {
      const raw = normalize(input.value);
      if (parseValue(raw)) map.set(raw, !!input.checked);
    });
    return map;
  };

  const findSizeSpans = () => {
    const spans = [];
    const seen = new Set();

    const addSpan = (span) => {
      if (!span || !span.isConnected || seen.has(span)) return;
      const stored = normalize(span.dataset.sssSizeRaw);
      const current = normalize(span.textContent);
      if (!parseValue(stored || current)) return;
      seen.add(span);
      spans.push(span);
    };

    getProductRoot().querySelectorAll('.swatch-button-title-text span').forEach(addSpan);

    const nativeFieldset = findNativeSizeFieldset();
    if (nativeFieldset) {
      nativeFieldset.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!parseValue(input.value)) return;
        const label = Array.from(nativeFieldset.querySelectorAll('label[for]'))
          .find((candidate) => candidate.htmlFor === input.id);
        addSpan(label?.querySelector('.option_name') || label);
      });
    }

    return spans;
  };

  const prepareSwatchSpan = (span) => {
    let raw = normalize(span.dataset.sssSizeRaw);
    if (!parseValue(raw)) {
      raw = normalize(span.textContent);
      if (!parseValue(raw)) return null;
      span.dataset.sssSizeRaw = raw;
    }
    const parsed = parseValue(raw);
    if (!parsed) return null;
    span.classList.add('sss-size-display');
    return { raw, parsed };
  };

  const syncSelectedSurface = (nativeState) => {
    Array.from(document.querySelectorAll('li.swatch-view-item'))
      .filter((item) => item.querySelector('.sss-size-display'))
      .forEach((item) => {
        const span = item.querySelector('.sss-size-display');
        const raw = span ? normalize(span.dataset.sssSizeRaw) : '';
        item.classList.toggle('sss-selected-surface', nativeState.get(raw) === true);
      });
  };

  const updateVisibleSwatches = (system, spans) => {
    const nativeState = getNativeSizeState();
    const sizeSpans = spans || findSizeSpans();

    sizeSpans.forEach((span) => {
      const data = prepareSwatchSpan(span);
      if (!data) return;
      const display = system === 'US' ? data.parsed.us : data.parsed.eu;
      if (normalize(span.textContent) !== display) span.textContent = display;

      const button = span.closest('.swatch-button');
      const nativeLabel = span.closest('label');
      const ariaLabel = (system === 'US' ? 'US ' : 'EU ') + display;

      if (nativeLabel) nativeLabel.setAttribute('aria-label', ariaLabel);

      if (button) {
        const selected = nativeState.get(data.raw) === true;
        button.classList.toggle('sss-size-selected', selected);
        button.setAttribute('aria-label', ariaLabel);
        if (selected) {
          button.style.setProperty('background-color', '#111', 'important');
          button.style.setProperty('border-color', '#111', 'important');
          span.style.setProperty('color', '#fff', 'important');
        } else {
          button.style.removeProperty('background-color');
          button.style.removeProperty('border-color');
          span.style.removeProperty('color');
        }
      }
    });

    syncSelectedSurface(nativeState);
    return sizeSpans.length;
  };

  const applySystem = (system) => {
    ensureStyles();
    const spans = findSizeSpans();

    if (spans.length < 2) {
      removeToggle();
      return false;
    }

    const toggle = ensureToggle();
    if (!toggle) return false;

    toggle.querySelectorAll('[data-sss-system]').forEach((button) => {
      const active = button.dataset.sssSystem === system;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateVisibleSwatches(system, spans);
    return true;
  };

  const init = () => applySystem(getSystem());

  window.SSSSizeToggle = {
    refresh: init,
    applySystem,
    getSystem
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('#sss-size-system-toggle [data-sss-system]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const system = button.dataset.sssSystem === 'US' ? 'US' : 'EU';
    try { localStorage.setItem(STORAGE_KEY, system); } catch (e) {}
    applySystem(system);
  }, true);

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.swatch-button');
    if (!swatch || !swatch.querySelector('.sss-size-display')) return;

    document.querySelectorAll('.swatch-button.sss-size-selected').forEach((button) => {
      if (button.querySelector('.sss-size-display')) {
        button.classList.remove('sss-size-selected');
        button.style.removeProperty('background-color');
        button.style.removeProperty('border-color');
        const oldSpan = button.querySelector('.sss-size-display');
        if (oldSpan) oldSpan.style.removeProperty('color');
      }
    });

    document.querySelectorAll('li.swatch-view-item.sss-selected-surface').forEach((item) => item.classList.remove('sss-selected-surface'));

    swatch.classList.add('sss-size-selected');
    swatch.style.setProperty('background-color', '#111', 'important');
    swatch.style.setProperty('border-color', '#111', 'important');
    const activeSpan = swatch.querySelector('.sss-size-display');
    if (activeSpan) activeSpan.style.setProperty('color', '#fff', 'important');
    const activeItem = swatch.closest('li.swatch-view-item');
    if (activeItem) activeItem.classList.add('sss-selected-surface');

    window.requestAnimationFrame(() => {
      window.setTimeout(() => applySystem(getSystem()), 0);
      window.setTimeout(() => applySystem(getSystem()), 150);
    });
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[type="radio"]')) return;
    setTimeout(() => applySystem(getSystem()), 0);
  });

  [0,100,250,500,900,1500,3000,5000].forEach((delay) => setTimeout(init, delay));
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('sss:variant-picker-updated', init);
  window.addEventListener('pageshow', init);

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(init, 100);
  });
  const startObserver = () => {
    if (document.body) observer.observe(document.body, { childList:true, subtree:true });
  };
  if (document.body) startObserver();
  else document.addEventListener('DOMContentLoaded', startObserver);
})();
